import { RouterProvider } from 'react-router-dom';
import { AppRoutes } from './routes/routes';
import { useCookieProInitialiser } from '@domgen/base-design-system-2.0/hooks/useCookieProInitialiser';
import { useEffect } from 'react';
import { LocaleProvider } from './context/locale/provider';

export function App() {
  const environment = import.meta.env.MODE;
  const { initialise } = useCookieProInitialiser(environment as 'sandbox' | 'development' | 'qa');

  useEffect(() => {
    const init = async () => {
      try {
        initialise(
          import.meta.env.VITE_COOKIE_PRO_BRAND_SCRIPT_ID,
          import.meta.env.VITE_COOKIE_PRO_SRC,
          // Only load cookie pro in QA and production as it is needed to block analytics in these environments.
          // In sandbox and development we want analytics to work without needing to set up cookie pro.
          // Also with ephemerals the behaviour of the setup is different
          ['qa', 'production'],
          'cookiePro',
        );
      } catch (error: unknown) {
        console.error('Error initializing cookie pro:', error);
      }
    };
    init();
  }, []);

  return (
    <LocaleProvider environment={environment as 'sandbox' | 'development' | 'qa' | 'production'}>
      <RouterProvider router={AppRoutes()} />
    </LocaleProvider>
  );
}
